import { render, staticRenderFns } from "./audio-player.vue?vue&type=template&id=9b0247ec"
import script from "./audio-player.vue?vue&type=script&lang=js"
export * from "./audio-player.vue?vue&type=script&lang=js"
import style0 from "./audio-player.vue?vue&type=style&index=0&id=9b0247ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports